import React, { useState, useEffect, useRef } from "react"
import {
  Col,
  Card,
  CardBody,
  Badge,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { Link } from "react-router-dom"
import { isEmpty, map } from "lodash"
import { getBlacklists as onGetBlacklists,updateBlacklist as onUpdateBlacklist } from "../../store/blacklists/actions"
import PropTypes from "prop-types"
import { seasonPasstSatusTypes, messageTitle, stations } from "constants/common"
import BlacklistCreate from "./BlacklistCreate"
// import { updateBlacklist as onUpdateBlacklist } from "../../store/actions"
import DeleteModal from "components/Common/DeleteModal"
//redux
import { useSelector, useDispatch } from "react-redux"
const sizePerPage = 25

const getColor = status => {
  if (status == seasonPasstSatusTypes.Removed || status == seasonPasstSatusTypes.Rejected) {
    return "danger"
  } else if (
    status == seasonPasstSatusTypes.Approved ||
    status == seasonPasstSatusTypes.Available
  ) {
    return "success"
  } else if (status == "Not-Available") {
    return "dark"
  } else {
    return "warning"
  }
}

const checkStatus = status => {
  if (status == seasonPasstSatusTypes.Removed || status == seasonPasstSatusTypes.Rejected) {
    return true
  } else {
    return false
  }
}

const checkLiveStatus = status => {
  if (status == "Pending" || status == "Offline") {
    return false
  } else {
    return true
  }
}

const emptyDataMessage = () => {
  return <p style={{ textAlign: "center" }}>No data to display</p>
}

const BlacklistList = props => {
  //const { setSelectedBlacklist, blacklist } = props
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [selectedBlacklist, setSelectedBlacklist] = useState(null)
  const { blacklistList } = useSelector(state => ({
    blacklistList: state.blacklists.blacklistList,
  }))
  const [deleteModal, setDeleteModal] = useState(false)

  const pageOptions = {
    sizePerPage: sizePerPage,
    totalSize: blacklistList?.length || 1,
    custom: true,
  }
  const keyField = "_id"
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  useEffect(() => {
    console.log("Blacklist updated")
    console.log(blacklistList)
  }, [blacklistList])

  const blacklistListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => <>{record._id}</>,
    },
    {
      text: "ID",
      dataField: "blacklistId",
      sort: true,
    },
    {
      text: "vehicle",
      dataField: "vehicle",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, blacklist) => (
        <Badge className={"bg-" + getColor(blacklist?.status)}>
          {blacklist?.status == "Approved" || blacklist?.status == "Available"
            ? "Live"
            : blacklist?.status}
        </Badge>
      ),
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
          
          <Link
            className={
              record?.status == "Not-Available" ? "text-success" : "text-black"
            }
            to="#"
            style={{
              opacity: checkStatus(record?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(record?.status) ? "none" : "auto",
            }}
          >
            <i
              className={
                record?.status == "Not-Available"
                  ? "mdi mdi-account-arrow-left font-size-24"
                  : "mdi mdi-account-cancel font-size-24"
              }
              id="edittooltip"
              onClick={e => handleBlockClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title={
                record?.status == "Not-Available" ? "Live Blacklist" : "Unlive Blacklist"
              }
            ></i>
          </Link>
          
        </div>
      ),
    },
  ]

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const onClickDelete = blacklist => {
    setSelectedBlacklist({ ...blacklist, action: "Removed" })
    setDeleteModal(true)
  }

  const handleBlockClick = blacklist => {
    if (blacklist?.status == "Not-Available") {
      setSelectedBlacklist({ ...blacklist, action: "Available" })
    } else {
      setSelectedBlacklist({ ...blacklist, action: "Not-Available" })
    }
    setDeleteModal(true)
  }


  const handleDeleteUser = () => {
    const updateBlacklist = {
      id: selectedBlacklist._id,
      status: selectedBlacklist.action,
    }
    dispatch(onUpdateBlacklist(updateBlacklist))
    setDeleteModal(false)
  }

  useEffect(() => {
    dispatch(onGetBlacklists())
  }, [dispatch])

  const toggle = () => {
    console.log("modal", modal)
    setModal(!modal)
  }

  const handleEditClick = blacklist => {
    setSelectedBlacklist(blacklist)
    console.log("first")
    setModal(true)
  }

  const handleAddClick = () => {
    setSelectedBlacklist(null)
    console.log("second")
    setModal(true)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        text={
          selectedBlacklist?.action == "Not-Available"
            ? "Yes, unlive it!"
            : (selectedBlacklist?.action == "Approved" || selectedBlacklist?.action == "Available")
            ? "Yes, live it!"
            : selectedBlacklist?.action == "Pending"
            ? "Yes, unlive it!"
            : "Yes, remove it!"
        }
        icon={
          selectedBlacklist?.action == "Not-Available"
            ? "mdi mdi-account-cancel"
            : (selectedBlacklist?.action == "Approved" || selectedBlacklist?.action == "Available")
            ? "mdi mdi-account-arrow-left"
            : "mdi mdi-account-minus"
        }
        iconColor={
          selectedBlacklist?.action == "Not-Available"
            ? "text-black"
            : (selectedBlacklist?.action == "Approved" || selectedBlacklist?.action == "Available")
            ? "text-success"
            : "text-danger"
        }
        bodyText={
          selectedBlacklist?.action == "Not-Available"
            ? `Unlive the blacklist: ${selectedBlacklist?.vehicle}`
            : (selectedBlacklist?.action == "Approved" || selectedBlacklist?.action == "Available")
            ? `Live the blacklist: ${selectedBlacklist?.vehicle}`
            : selectedBlacklist?.action == "Pending"
            ? `Unlive blacklist: ${selectedBlacklist?.vehicle}`
            : `Remove blacklist: ${selectedBlacklist?.vehicle}`
        }
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              {/* <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={blacklistListColumns}
                data={blacklistList || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return ( */}
                    <ToolkitProvider
                      keyField={keyField}
                      data={blacklistList || []}
                      columns={blacklistListColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="8"></Col>
                            <Col sm="4">
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={handleAddClick}
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add New Blacklist
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  // {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={
                                    "table align-middle table-nowrap table-hover"
                                  }
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                />
                              </div>
                            </Col>
                          </Row>
                          {/* <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row> */}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
              {/*     )
                }}
              </PaginationProvider> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {console.log("modal ====>", modal)}
      {modal && (
        <BlacklistCreate
          isOpen={modal}
          toggle={() => toggle()}
          blacklist={selectedBlacklist}
          history={null}
          setSelectedBlacklist={setSelectedBlacklist}
        />
      )}
    </React.Fragment>
  )
}

export default BlacklistList
BlacklistList.propTypes = {
  setSelectedBlacklist: PropTypes.func,
  blacklist: PropTypes.object,
}
